export default __webpack_public_path__ + "static/media/Final_Sa.c24db321.png";